import { formatHtml } from "@trumpf/ux.common-storybook";
import { getIframePageDecorators } from "../../../shared/page";
import { SocialMediaWallTemplate } from "./social-media-wall.templates";

export default {
    title: "Website/Partial Templates/Social Media Wall (H.21)",
    render: SocialMediaWallTemplate.bind({}),
    tags: ["autodocs"],
    decorators: getIframePageDecorators(),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
        layout: "fullscreen",
    },
};

export const SocialMediaWall = {};
